
export default function PDF({url, width, height}){

    return <iframe 
        title="PDF" 
        src={url}
        width={width || '100%'}
        height={height || '600px'}
        frameBorder="0"
    >
        Failed to load PDF
    </iframe>
}